<template>
  <li class="libraryItem"
      @click.stop="toLibraryInfo(library.id,library.hallCode,library.libName,library.libLevel,library.logoUrl,library.websiteUrl)">
    <img class="l" :src="imgPath+library.logoUrl" width="140" height="140" alt="图片"/>
    <div class="libraryInfo">
      <div class="libraryName ellip" :title="library.libName">{{library.libName}}</div>
      <!--<div class="hallCode ellip">藏书量 : {{Number(library.bookNum)>10000?(Number(library.bookNum)/10000).toFixed(1)+'万':library.bookNum}}</div>-->
      <!--<div class="hallType ellip">电子书量 : {{Number(library.ebookNum)>10000?(Number(library.ebookNum)/10000).toFixed(1)+'万':library.ebookNum}}</div>-->
      <div class="hallCode ellip">纸质藏书 : {{library.bookNum}}</div>
      <div class="hallType ellip">电子藏书 : {{library.ebookNum}}</div>
      <div class="area ellip" :title="library.address">地址 : {{library.address}}</div>
    </div>
  </li>
</template>

<script>
  import {store} from '../store/store';
  import {imgPath} from "../common/config";

  export default {
    name: 'library',
    props: ['library'],
    data() {
      return {
        imgError: store.imgError,
        imgPath:imgPath
      }
    },
    created: function () {
    },
    methods: {
      toLibraryInfo(libId, libCode, libName, libLevel, logo,websiteUrl)
      {
        if(websiteUrl!=null && websiteUrl.trim()!=""){
          window.open(websiteUrl);
          return;
        }
        store.library.id = libId;
        store.library.libraryLevel = libLevel;
        store.library.name = libName;
        var lngLat = this.$route.query.latLng || store.localtionArea.latLng;
        var locationCode = this.$route.query.code || "510107";
        this.$router.push({
          path: '/introduce', query: {
            libId: libId,
            fromSearch: this.$route.query.fromSearch,
            libCode: libCode,
            libName: libName,
            libLevel: libLevel,
            latLng: lngLat,
            locationCode: locationCode,
            logo: logo,
          }
        });
      }
    }
  }
</script>

<style scoped lang="sass">
    .web2
      .libraryItem
        &:hover
          .libraryName
            color: $themecolor2
    .libraryItem
      margin-bottom: 30px
      width: 140px+316px
      height: 140px
      border: 1px solid #eee
      cursor: pointer
      &:hover
        background: #f8f8f8
        .libraryName
          color: $themecolor1
          text-decoration: underline

      .libraryInfo
        margin:
          right: 49px
        overflow: hidden
        padding:
          left: 35px
          top: 20px
        height: 100%
        border:
          left: 1px solid #eee
        font-size: 14px
        color: #333

      .libraryName
        margin-bottom: 6px
        font-size: 18px
        line-height: 26px
        color: #333

      .hallCode, .hallType, .area
        margin-bottom: 5px
        line-height: 20px
</style>
